import Collection from '@/components/Collection'
import CreateRegistrar from '@/pages/registrar/CreateForm'
import ViewRegistrar from '@/pages/registrar/Detail'
import EditRegistrar from '@/pages/registrar/Update'
import access from '../access'

const regNs = "urn:ietf:params:xml:ns:registrar-info-1.0";

export default {

  'registrar.collection': {
    path: '/admin/registrars',
    name: 'registrar.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listRegistrars",
      entity: "registrar",
      cols: [
        { label: "Organization", field: "org" },
        { label: "Name", field: "name" },
        { label: "E-mail", field: "email" },
        { label: "Country", field: "country", flag: true, sort: "country" },
        { label: "Credit", field: "credit", sort: "credit" },
      ],
      actions: (row) => {
        return [
          { name: "registrar.view", label: "view", icon: "eye", params: {id: row.id} },
          { name: "registrar.update", label: "edit", icon: "pencil2", params: {id: row.id} }
        ];
      }
    },
    meta: {
      access: access.chain(access.admin, access.service(regNs)),
      title: "Registrar list",
      side_menu: { label: "Registrars",  icon: "user-tie" },
      local_actions: [
        { name: "registrar.create", label: "Create registrar", color: "success", icon: "plus" }
      ]
    },
  },

  'registrar.view': {
    path: '/admin/registrars/view/:id',
    name: 'registrar.view',
    component: ViewRegistrar,
    props: (route) => {
      return {
        id: Number(route.params.id),
      }
    },
    meta: {
      access: access.chain(access.admin, access.service(regNs)),
      title: "Registrar details",
      local_tasks: [
        { name: "registrar.view", label: "View"},
        { name: "registrar.update", label: "Edit"}
      ]
    },
  },

  'registrar.create': {
    path: '/admin/registrars/create',
    name: 'registrar.create',
    component: CreateRegistrar,
    meta: {
      access: access.chain(access.admin, access.service(regNs)),
      title: "Create new registrar"
    },
  },

  'registrar.update': {
    path: '/admin/registrars/edit/:id',
    name: 'registrar.update',
    component: EditRegistrar,
    props: (route) => {
      return {
        id: Number(route.params.id),
      }
    },
    meta: {
      access: access.chain(access.admin, access.service(regNs)),
      title: "Update registrar details",
      local_tasks: [
        { name: "registrar.view", label: "View"},
        { name: "registrar.update", label: "Edit"}
      ]
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/registrar.js